import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Doughnut = _resolveComponent("Doughnut")!

  return (_openBlock(), _createBlock(_component_Doughnut, {
    "chart-data": _ctx.data,
    "chart-id": _ctx.chartId,
    "chart-options": _ctx.chartOptions,
    "css-classes": _ctx.cssClasses,
    "dataset-id-key": _ctx.datasetIdKey,
    height: _ctx.chartHeight,
    plugins: _ctx.chartPlugins,
    styles: _ctx.styles,
    width: _ctx.chartWidth,
    class: "doughnut-chart"
  }, null, 8, ["chart-data", "chart-id", "chart-options", "css-classes", "dataset-id-key", "height", "plugins", "styles", "width"]))
}